import React from 'react';
import { FadeIn } from './FadeIn';
import { Sparkles } from 'lucide-react';
export function HeroImage() {
  return <section className="bg-white pb-20 px-6 md:px-12 lg:px-24" data-id="element-79">
      <div className="max-w-5xl mx-auto" data-id="element-80">
        <FadeIn delay={0.3} data-id="element-81">
          <div className="relative w-full rounded-2xl overflow-hidden shadow-xl" data-id="element-82">
            {/* Full hero image */}
            <div className="relative aspect-video" data-id="element-83">
              <img src="https://cdn.magicpatterns.com/uploads/dRR4RNUXjKFUyQgJNv4XXg/banner_Pagina_de_Venta_fuego_nadie_ve.png" alt="Ingredientes antiinflamatorios naturales sobre mesa de madera rústica: jengibre, ajo, cúrcuma, limones, canela, perejil, vinagre de manzana, cebolla morada y pimienta negra" className="w-full h-full object-cover" data-id="element-84" />

              {/* Warm overlay for text readability */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" data-id="element-85" />

              {/* Top label */}
              <div className="absolute top-6 left-0 right-0 z-10" data-id="element-86">
                <FadeIn delay={0.5} data-id="element-87">
                  <p className="text-center text-sm md:text-base uppercase tracking-[0.2em] text-white/80 font-bold drop-shadow-lg" data-id="element-88">
                    La botica de tu cocina
                  </p>
                </FadeIn>
              </div>

              {/* Bottom tagline overlay */}
              <div className="absolute bottom-0 left-0 right-0 z-10 p-6 md:p-10" data-id="element-89">
                <FadeIn delay={0.7} data-id="element-90">
                  <div className="flex items-center justify-center gap-3 mb-2" data-id="element-91">
                    <Sparkles className="text-gold" size={20} data-id="element-92" />
                    <p className="text-lg md:text-2xl font-serif text-white font-medium text-center drop-shadow-lg" data-id="element-93">
                      Ingredientes naturales de tu cocina • Protocolo de 7 días
                      • Resultados reales
                    </p>
                    <Sparkles className="text-gold" size={20} data-id="element-94" />
                  </div>
                  <p className="text-center text-sm md:text-base text-white/70 drop-shadow-md" data-id="element-95">
                    Menos de $15 dólares a la semana en cualquier mercado de
                    barrio
                  </p>
                </FadeIn>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}